import React from 'react';
import {connect} from 'react-redux';
import Dropzone from 'react-dropzone';
import { setActivitiesOpen, setImagesPreview, setImages } from '../../../../actions/create-action';

import { store } from '../../../../store';
const mapStateToProps = (state) => {

  let imagesPreview = state.imagesPreview;
  let open = state.activities.open;
  

  return {
    imagesPreview: imagesPreview,
    open: open,
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    onImages: (images) => dispatch(setImagesPreview(images)),
    onOpen: (open) => dispatch(setActivitiesOpen(open)),
    onImagesAction: (image) => dispatch(setImages(image)),
  }
}

const initialstate = {

//Image section
    addimage:false,
    deleted: false,
    img: [],
    imag_preview: [],
    imgdel: false,
    img_pdel: false
  };
class ImageUploadFunction extends React.Component {
	constructor(props) {
		super(props)
		this.state = initialstate
	}
  componentDidMount() {
  let {images, imagesPreview} = store.getState()
  let {img, img_preview} = this.state
  if(images !== img)
  this.setState({
    img: images
  })
  if(imagesPreview !== img_preview)
  this.setState({
    img_preview: imagesPreview
  })
  }
handleImageChange = (files, images) =>            
 {             

    let reader = new FileReader();
    let file = files[0];
    let newurl = file && URL.createObjectURL(file);
    let btnclass = store.getState().activities.open;


      reader.onload = (e) => {
  
      let newImage= {
                     img_url: newurl,
                     alt_name : btnclass,
                     file : file
                   }
      let flag=0;

          if(store.getState().imagesPreview === null)
          {
              this.props.onImages(newImage)
              this.props.onOpen('')
              this.setState({addimage:true})
          }
          else
          {
              let arr = store.getState().imagesPreview;

              for(let i=0; i<arr.length; i++)
              {
                if(arr[i].alt_name === btnclass )
                {
                   arr[i].img_url = newurl;
                   arr[i].file = file;
                   this.props.onImages(arr)
                   this.props.onOpen('')
                   this.setState({addimage:true})
                   flag = 1;
                }
              }
              if(flag === 0)
              {
                let concatedimagearray = store.getState().imagesPreview.concat(newImage);
                this.props.onImages(concatedimagearray)
                   this.props.onOpen('')
                this.setState({addimage:true})
              }
          }
      }
    reader.readAsDataURL(file)
    this.setState({addimage:true})
  }

Delimg = () => {
  let {activities, user} = store.getState()
  let {img, img_preview} = this.state
  if(store.getState().images.length !== 0) {
  img.map((value, i) => {
    if(value.alt_name === activities.open && value.img_url !== null) {
      fetch(`${process.env.REACT_APP_API}/delimg`, {
          method: 'post',
          headers: {'Content-Type': 'application/json'},
          body: JSON.stringify({
            images: img[i],
            token: user.token,
            user: {
              username: user.user.username
            }
          })
        })
      .then((response) => response.json())
      .then((data)=>{
        console.log(data)
        if(data.images) {
          let arr = img
          arr[i].img_url = null
          this.props.onImagesAction(arr)
          this.setState({
            img: arr,
            imgdel: true
          })
        }
      })
      }
    })
  }
    let ar = img_preview
    let del = null
    ar.map((value,i)=> {
        if(ar[i].alt_name === activities.open)
              {
                let del = ar.splice(i,1)
              }
    })
    this.props.onImages(ar)
    this.setState({
      img_pdel: true,
      img_preview: ar
    })
}
render() {
  if(store.getState().activities.open === 'propic' ||
    store.getState().activities.open === 'cover') {
  return(
    <div
    className="img_upload"
    >
    <div className="img_upload_inside"
    onMouseOver={this.props.onClickInside.bind()}
    onMouseOut={this.props.onClickOutside.bind()}>
    <Dropzone
          onDrop={this.handleImageChange.bind(this)}
          multiple={false}
          accept="image/*"
          className="inp"
          type="file"
      >
    <div className="drop_in">
    <span className="dropimg"><span className="fa fa-upload" /> Drop an image/click to select a file to upload <span className="dropimg_warn">(Try uploading small sized images for getting the best performance)</span></span></div>
    </Dropzone>

    <span className="del_img" onClick={this.Delimg.bind(this)}>Remove Saved Image</span>
    </div>
    <span href="#" className="close closeblack" onClick={()=> { this.props.onOpen('')}}/>
  </div>)
  }
  else return null  
}
}
export default connect(mapStateToProps, mapDispatchToProps)(ImageUploadFunction)